import { Component } from '@angular/core';
import {StoreService} from './resources/services/store.service';
import {ScreenService} from './resources/services/screen.service';
import {NavigationStart, Router, RouterEvent} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {

  constructor(public storeService: StoreService,
              public screenService: ScreenService,
              private _router: Router) {

    _router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });

  }

  navigationInterceptor(event: RouterEvent) {
    if (event instanceof NavigationStart)
      this.hideSidebar();
  }

  hideSidebar() {
    if (this.isDesktop()) return;

    this.storeService.actions.hideSidebar();
  }

  isDesktop() {
    return this.screenService.up('lg');
  }
}
